/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acc_Type_IndividualInputs */

const en_acc_type_individual = /** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual Creator`)
};

const es_acc_type_individual = /** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador Individual`)
};

const fr_acc_type_individual = /** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur individuel`)
};

const de_acc_type_individual = /** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individueller Creator`)
};

const id_acc_type_individual = /** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreator Individu`)
};

/** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */
const ja_acc_type_individual = en_acc_type_individual;

/** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */
const zh_acc_type_individual = en_acc_type_individual;

/** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */
const ar_acc_type_individual = en_acc_type_individual;

/** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */
const it_acc_type_individual = en_acc_type_individual;

/** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */
const ru_acc_type_individual = en_acc_type_individual;

/** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */
const pt_acc_type_individual = en_acc_type_individual;

/** @type {(inputs: Acc_Type_IndividualInputs) => LocalizedString} */
const ko_acc_type_individual = en_acc_type_individual;

/**
* | output |
* | --- |
* | "Individual Creator" |
*
* @param {Acc_Type_IndividualInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acc_type_individual = /** @type {((inputs?: Acc_Type_IndividualInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acc_Type_IndividualInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acc_type_individual(inputs)
	if (locale === "es") return es_acc_type_individual(inputs)
	if (locale === "fr") return fr_acc_type_individual(inputs)
	if (locale === "de") return de_acc_type_individual(inputs)
	if (locale === "ja") return ja_acc_type_individual(inputs)
	if (locale === "zh") return zh_acc_type_individual(inputs)
	if (locale === "ar") return ar_acc_type_individual(inputs)
	if (locale === "id") return id_acc_type_individual(inputs)
	if (locale === "it") return it_acc_type_individual(inputs)
	if (locale === "ru") return ru_acc_type_individual(inputs)
	if (locale === "pt") return pt_acc_type_individual(inputs)
	return ko_acc_type_individual(inputs)
});